import gql from 'graphql-tag';

export const GET_ADS_IDS = gql`
  query GET_ADS_IDS($campaignsIds: [ID!], $lineItemsIds: [ID!], $limit: Int!) {
    ads: adsV5(
      filterOptions: { campaignIdList: $campaignsIds, lineItemIdList: $lineItemsIds }
      paginationOptions: { limit: $limit }
    ) {
      edges {
        node {
          id
          # Caches each ad's parent line item, as GET_LINE_ITEMS_IDS does for campaigns. The id
          # alone is enough: that line item's own campaign arrives from GET_LINE_ITEMS_IDS.
          lineItem {
            id
          }
        }
      }
    }
  }
`;
